import { render, staticRenderFns } from "./ShipmentTypeUpdateDialog.vue?vue&type=template&id=d96e7200&scoped=true"
import script from "./ShipmentTypeUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./ShipmentTypeUpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96e7200",
  null
  
)

export default component.exports